import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Instagram, Facebook, Clock } from 'lucide-react';
import { useRestaurantData } from '../hooks/useRestaurantData';
import './Contact.css';

const Contact = () => {
    const data = useRestaurantData();
    const address = "65 bis Avenue Paul Doumer, 78360 Montesson";
    const phone = "01 23 45 67 89";
    const email = "contact@sugarhut.fr";

    const daysTranslation = {
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche'
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="contact-page"
        >
            <div className="container">
                <div className="contact-grid">
                    {/* Contact Info */}
                    <div className="contact-info-section">
                        <div>
                            <h1 className="contact-title">Venez nous voir !</h1>
                            <p className="contact-subtitle">Une envie de burger ? On vous attend à Montesson pour une expérience inoubliable.</p>
                        </div>

                        <div className="contact-cards">
                            <div className="contact-card group">
                                <div className="card-icon bg-primary">
                                    <MapPin size={24} />
                                </div>
                                <div>
                                    <p className="card-label">Adresse</p>
                                    <p className="card-value">{address}</p>
                                </div>
                            </div>

                            <div className="contact-card group">
                                <div className="card-icon bg-secondary">
                                    <Phone size={24} />
                                </div>
                                <div>
                                    <p className="card-label">Téléphone</p>
                                    <p className="card-value">{phone}</p>
                                </div>
                            </div>

                            <div className="contact-card group">
                                <div className="card-icon bg-dark">
                                    <Mail size={24} />
                                </div>
                                <div>
                                    <p className="card-label">Email</p>
                                    <p className="card-value">{email}</p>
                                </div>
                            </div>
                        </div>

                        {/* Opening Hours Card */}
                        <div className="hours-card">
                            <h3 className="hours-title italic font-black">
                                <Clock className="text-primary" /> Nos Horaires
                            </h3>
                            <div className="hours-list">
                                {Object.entries(data.restaurant.hours).map(([day, hours]) => (
                                    <div key={day} className="hour-row">
                                        <span className="hour-day">{daysTranslation[day]}</span>
                                        <span className="hour-time">{hours.open} - {hours.close}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Social Links */}
                        <div className="social-links">
                            <a href="#" className="social-btn">
                                <Instagram size={24} />
                            </a>
                            <a href="#" className="social-btn">
                                <Facebook size={24} />
                            </a>
                        </div>
                    </div>

                    {/* Map and Form */}
                    <div className="map-form-section">
                        <div className="map-wrapper">
                            <iframe
                                title="google-maps"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2621.3644917424424!2d2.0882299!3d48.918001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e6616094ab68c9%3A0xe54930be6289f1c!2s65%20Bis%20Av.%20Paul%20Doumer%2C%2078360%20Montesson!5e0!3m2!1sfr!2sfr!4v1717594512345!5m2!1sfr!2sfr"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>

                        <form className="contact-form">
                            <h3 className="form-title">Envoyez-nous un message</h3>
                            <div className="form-row">
                                <div className="form-group">
                                    <label className="form-label">Prénom</label>
                                    <input className="form-input" placeholder="Jean" />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Nom</label>
                                    <input className="form-input" placeholder="Dupont" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="form-label">Email</label>
                                <input className="form-input" placeholder="jean.dupont@email.com" />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Message</label>
                                <textarea className="form-textarea" rows="4" placeholder="Votre message ici..."></textarea>
                            </div>
                            <button className="submit-btn">
                                Envoyer l'équipe !
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default Contact;
